
import * as React from 'react'
import {
    Business, LocalGasStation, Money, Call,
    Payments, Receipt, AssignmentInd, Message, LocationOn
} from '@mui/icons-material'
import { Button, Divider } from '@mui/material'
import { connect } from 'react-redux'
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemIcon from '@mui/material/ListItemIcon'
import IntlMessages from '../../../util/IntlMessages'
import * as tools from '../../../util/tools'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import Avatar from '@mui/material/Avatar'
import * as constants from '../../../constants'

function Content(props) {

    const getItems = (title, icon, message) => {
        return (
            <>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar>
                            {icon}
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={title} secondary={message} />
                </ListItem>
                <Divider />
            </>
        )
    }

    const getVolume = () =>
        tools.numberformat(props.iVolumeReceived === -1 ? props.iVolumeRequested : props.iVolumeReceived)

    const getServicePrice = () =>
        props.iPaymentType === constants.PAYMENT_TYPE_CASH ? tools.numberformat(props.price.iServicePrice) : '-'

    const getTotalAmount = () => {
        let totalAmont = props.iTotalPrice
        if (props.iPaymentType !== constants.PAYMENT_TYPE_CASH) {
            totalAmont = totalAmont - props.price.iServicePrice
            totalAmont = totalAmont < 0 ? 0 : totalAmont
        }
        return tools.numberformat(totalAmont)
    }

    return (
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {getItems(<IntlMessages id="organizationName" />, <Business fontSize="small" />, props.vOrganizationName)}
            {getItems(<IntlMessages id="recipientName" />, <AssignmentInd fontSize="small" />, props.vRecipientName)}
            {getItems(<IntlMessages id="litrage" />, <LocalGasStation fontSize="small" />, getVolume())}
            {getItems(<IntlMessages id="servicePrice" />, <Money fontSize="small" />, getServicePrice())}
            {getItems(<IntlMessages id="totalAmont" />, <Money fontSize="small" />, getTotalAmount())}
            {getItems(<IntlMessages id="paymentType" />, <Payments fontSize="small" />, tools.getPaymentType(props.iPaymentType))}
            {getItems(<IntlMessages id="statusRecepit" />, <Receipt fontSize="small" />, tools.getReceiptStatus(props.iPaymentType))}
            <MenuItem onClick={() => window.location.href = tools.telFormat(props.vReceiveDeliveryPhone)}>
                <ListItemIcon>
                    <Button startIcon={<Call fontSize="small" />} variant='text'>
                        <IntlMessages id="contactUser" />
                    </Button>
                </ListItemIcon>
            </MenuItem>
            <Divider />
            {getItems(<IntlMessages id="address" />, <LocationOn fontSize="small" />, props.organizationDetails.vAddress)}
            {getItems(<IntlMessages id="description" />, <Message fontSize="small" />, props.vComment)}
        </List>
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Content)
